import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { MobileContactBar } from "@/components/MobileContactBar";

import Home from "@/pages/Home";
import ServicesHub from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Packages from "@/pages/Packages";
import Portfolio from "@/pages/Portfolio";
import ProcessPage from "@/pages/Process";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Admin from "@/pages/Admin";

import "@/App.css";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

const RouteWrapper = ({ children }) => {
    const { pathname } = useLocation();
    const isAdmin = pathname.startsWith("/admin");
    return (
        <div className="min-h-screen flex flex-col bg-white">
            {!isAdmin && <Navbar />}
            <main className="flex-1 pb-16 lg:pb-0">{children}</main>
            {!isAdmin && <Footer />}
            {!isAdmin && <MobileContactBar />}
        </div>
    );
};

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Toaster position="top-right" richColors />
            <RouteWrapper>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/uslugi" element={<ServicesHub />} />
                    <Route path="/strony-internetowe" element={<ServiceDetail />} />
                    <Route path="/aplikacje" element={<ServiceDetail />} />
                    <Route path="/branding" element={<ServiceDetail />} />
                    <Route path="/social-media" element={<ServiceDetail />} />
                    <Route path="/marketing" element={<ServiceDetail />} />
                    <Route path="/automatyzacje-ai" element={<ServiceDetail />} />
                    <Route path="/pakiety" element={<Packages />} />
                    <Route path="/realizacje" element={<Portfolio />} />
                    <Route path="/proces" element={<ProcessPage />} />
                    <Route path="/o-nas" element={<About />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug" element={<BlogPost />} />
                    <Route path="/kontakt" element={<Contact />} />
                    <Route path="/polityka-prywatnosci" element={<Legal doc="polityka-prywatnosci" />} />
                    <Route path="/polityka-cookies" element={<Legal doc="polityka-cookies" />} />
                    <Route path="/regulamin" element={<Legal doc="regulamin" />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </RouteWrapper>
        </BrowserRouter>
    );
}

export default App;
